import React, { Component } from 'react'

const $ = require('jquery')
$.Datatable = require('datatables.net-dt')

export default class Tbl extends Component {

    componentDidMount() {
        // console.log(this.el);
        this.$el = $(this.el)
        this.$el.DataTable(
            {
                data: this.props.data,
                columns: [
                    {title:"No"},
                    {title:"Name"},
                    {title:"Phone"},
                    {title:"Email"},
                    {title:"City"}
                ]
            }
        )
    }

    render() {
        return <div>
            <table className="display" width="100%" ref={el => this.el = el} >

            </table>
        </div>
    }

}